export default {
  title: 'Tabless',
  form: {
    tabless_id: {
      label: 'Tabless-ID',
      placeholder: 'Internt ID i Tabless-systemet',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    error: 'Kunne ikke gemme ændringerne',
    success: 'Ændringerne er gemt',
  },
  connected: {
    title: 'Tabless er forbundet',
    description: 'Denne integration er sat op.',
  },
};
